import { render } from "./RedirectPreferredDate.vue?vue&type=template&id=44b0c68a"
import script from "./RedirectPreferredDate.vue?vue&type=script&lang=js"
export * from "./RedirectPreferredDate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/v3/RedirectPreferredDate.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "44b0c68a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('44b0c68a', __exports__)) {
    api.reload('44b0c68a', __exports__)
  }
  
  module.hot.accept("./RedirectPreferredDate.vue?vue&type=template&id=44b0c68a", () => {
    api.rerender('44b0c68a', render)
  })

}


export default __exports__